import { render, staticRenderFns } from "./PbInput.vue?vue&type=template&id=2dbdf126&"
import script from "./PbInput.vue?vue&type=script&lang=js&"
export * from "./PbInput.vue?vue&type=script&lang=js&"
import style0 from "./PbInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports